var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { colorTheme } from '@/ui-toolkit/mixin/colorTheme';
import { TableRow, tableRowMod } from './TableRowContent';
export var EmptyRow = styled(TableRow)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n\n    ", "\n"], ["\n    ", ";\n\n    ", "\n"])), colorTheme({
    '--container-empty-row     ': {
        dark: 'var(--gray-14)',
        light: 'var(--slate-04)',
    },
}), tableRowMod("\n        background-color: var(--container-empty-row);\n    "));
var templateObject_1;
